module.exports = __webpack_public_path__ + "static/media/algorand.9ad91b26.png";